export enum BookingAvailabilityType {
  Daily = "Daily",
  Open = "Open",
  Overnight = "Overnight",
  ByDay = "ByDay"
}

export type BookingStatus =
  | "Pending"
  | "Approved"
  | "Expired"
  | "Event"
  | "Cancelled"
  | "Denied"
  | "PendingPayment"
  | "Fitness";

export interface AmenityBookingRequest {
  amenityBookingId: number;
  userId: number;
  propertyUnitLeaseId: number;
  propertyId: number;
  amenitySpaceId: number;
  startTime: Date | string | null;
  endTime: Date | string | null;
  description: string | null;
  additionalDetails: string;
  waiverAccepted: boolean;
  amenitySpaceWaiverId: number | null;
}

export interface Availability {
  startTime: string | Date;
  endTime: string | Date;
  availableSlotText: string;
  availabilityType: number;
  availabilityTypeString: AvailabilityType;
}

export type AvailabilityType = "Available" | "Booked" | "Blocked" | "Unknown";

export interface BaseAmenitySpace {
  amenitySpaceId: number;
  bookingAvailabilityType: BookingAvailabilityType;
  name: string;
  price: number;
  imageUri: string;
  displayAvailabilityInDays: number;
  minDuration: number | null;
  maxDuration: number | null;
  waiver: Waiver | null;
  isAutoApproval: boolean;
  isOpenAmenity: boolean;
  checkinTime: number | null;
  checkoutTime: number | null;
  paymentRequired: boolean;
  invoiceUrl: string | null;
  timezone: string;
  isConditionalAccessEnabled: boolean;
}
export interface Waiver {
  amenitySpaceWaiverId: number;
  amenitySpaceId: number;
  required: boolean;
  disclaimer: string;
}
